export { default, getCrop, getImatge, hasImatge, getPeu, tipusImatgePredef } from './Imatge';
